import type { EventBusKey } from "@vueuse/core";

export const notificationKey: EventBusKey<"request" | "granted" | "denied"> =
  Symbol("notification");

export const toastKey: EventBusKey<"info" | "success" | "danger"> =
  Symbol("toast");
